module.exports = __webpack_public_path__ + "img/enTxt4.be719b5c.png";